// extracted by mini-css-extract-plugin
module.exports = {"mediaWrapper":"_25g8V","heading":"_2wJgf","subHeading":"_3EaRe","alertmsg-box":"_3WRAl","request-raised":"OzwrL"};